import { users } from '../../mock/users.json'
import { getDateStamps } from '../../lib/utils'

const state = {
  users,
}

const getters = {
  users: state => state.users,
  getUser: state => id =>
    state.users.find(user => user.id === parseInt(id, 10)),
}

const mutations = {
  setUsers(state, users) {
    console.debug('vuex.setUsers', users)
    state.users = [].concat(users)
  },
  addUser(state, user) {
    console.debug('vuex.addUser', user)
    const dates = getDateStamps()
    state.users.push(Object.assign({}, user, dates))
  },
  updateUser(state, changes) {
    const i = state.users.findIndex(o => o.id === changes.id)
    console.debug('vuex.updateUser', state.users[i], changes)
    const dates = getDateStamps(true)
    Object.assign(state.users[i], changes, dates)
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
